<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Categorias" pageTitle="Categorias" />
            <CategoriesContent />
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader';
import PageTitle from '../Common/PageTitle';
import CategoriesContent from '../Categories/CategoriesContent';
import FooterArea from '../Layouts/FooterArea';

export default {
    name: 'CategoriesPage',
    components: { MainHeader, PageTitle, CategoriesContent, FooterArea },
    mounted() { document.body.classList.add('body-bg-f8faff'); },
};
</script>
